import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ProcessPage from './pages/ProcessPage';
import IndustriesPage from './pages/IndustriesPage';
import IndustryDetailPage from './pages/IndustryDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SchedulePage from './pages/SchedulePage';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import VideosPage from './pages/VideosPage';
import WebinarsPage from './pages/WebinarsPage';
import SimpleResourcePage from './pages/SimpleResourcePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="process" element={<ProcessPage />} />
          <Route path="industries" element={<IndustriesPage />} />
          <Route path="industries/:slug" element={<IndustryDetailPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="schedule" element={<SchedulePage />} />
          <Route path="resources/blog" element={<BlogListPage />} />
          <Route path="resources/blog/:slug" element={<BlogDetailPage />} />
          <Route path="resources/videos" element={<VideosPage />} />
          <Route path="resources/webinars" element={<WebinarsPage />} />
          <Route
            path="resources/seo"
            element={
              <SimpleResourcePage
                title="SEO Guides"
                eyebrow="SEO"
                description="Step-by-step technical SEO + on-page guides from THINKINGWORLD."
                path="/resources/seo"
                message="Step-by-step technical &amp; on-page SEO guides — coming soon. Talk to us in the meantime."
              />
            }
          />
          <Route
            path="resources/case-studies"
            element={
              <SimpleResourcePage
                title="Case Studies"
                eyebrow="Case studies"
                description="Real THINKINGWORLD projects, real numbers."
                path="/resources/case-studies"
                message="Real projects, real numbers — case studies are being prepared. Reach out for early access."
              />
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route path="admin" element={<AdminLoginPage />} />
        <Route path="admin/dashboard" element={<AdminDashboardPage />} />
      </Routes>
    </div>
  );
}

export default App;
